import { Routes } from '@angular/router';
import { APP_ROUTES } from './appRoutes';

export const CONTENT_ROUTES: Routes = [
     {
        path: APP_ROUTES.root,
        loadChildren: () => import('../../pages/content-pages/content-pages.module').then(m => m.ContentPagesModule)
    }
];
